import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color", "size", "strokeWidth", "showText", "loadingText"];
import React, { useContext } from 'react';
import { StencilContext } from "../context";
import { cssProp, getUniqueId } from "../utils";
import { jsx as ___EmotionJSX } from "@emotion/core";
export var SpinnerSvg = function SpinnerSvg(_ref) {
  var colorProp = _ref.color,
      size = _ref.size,
      strokeWidth = _ref.strokeWidth,
      showText = _ref.showText,
      loadingText = _ref.loadingText,
      outerProps = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(StencilContext),
      selectors = _useContext.selectors;

  var spinnerId = getUniqueId('spinner');
  var color = cssProp(selectors.color, colorProp);
  return ___EmotionJSX("svg", _extends({
    role: showText ? undefined : 'img',
    width: size,
    height: size,
    "aria-hidden": showText,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, outerProps), !showText && loadingText && ___EmotionJSX("title", null, loadingText), ___EmotionJSX("defs", null, ___EmotionJSX("mask", {
    id: "".concat(spinnerId, "-mask")
  }, ___EmotionJSX("circle", {
    r: size / 2 - strokeWidth / 2,
    cx: size / 2,
    cy: size / 2,
    stroke: "white",
    strokeWidth: strokeWidth,
    "data-test-id": "StencilSpinnerMask"
  }))), ___EmotionJSX("defs", null, ___EmotionJSX("linearGradient", {
    id: "".concat(spinnerId, "-gradient")
  }, ___EmotionJSX("stop", {
    offset: "10%",
    stopColor: color,
    stopOpacity: 0
  }), ___EmotionJSX("stop", {
    offset: "50%",
    stopColor: color
  }))), ___EmotionJSX("circle", {
    cx: size / 2,
    cy: strokeWidth / 2,
    r: strokeWidth / 4,
    stroke: "url(#".concat(spinnerId, "-gradient)"),
    strokeWidth: strokeWidth / 2,
    "data-test-id": "StencilSpinnerTopCircle"
  }), ___EmotionJSX("circle", {
    r: size / 2 - strokeWidth / 2,
    cx: size / 2,
    cy: size / 2,
    stroke: color,
    strokeOpacity: 0.3,
    strokeWidth: strokeWidth,
    "data-test-id": "StencilSpinnerBottomCircle"
  }), ___EmotionJSX("foreignObject", {
    x: 0,
    y: 0,
    width: size,
    height: size,
    mask: "url(#".concat(spinnerId, "-mask)")
  }, ___EmotionJSX("div", {
    id: "".concat(spinnerId, "-conic-gradient"),
    style: {
      width: size,
      height: size,
      borderRadius: '50%',
      background: "\n            conic-gradient(\n              rgba(23,104,201,0),\n              rgba(23,104,201,0),\n              ".concat(color, "\n            )")
    }
  })));
};